
<template>
    <div class="pane" :class="{ 'is-loading': loading }">
        <template v-if="shoot">
            <header>
                <h1>Shoot / {{ shoot.title }}</h1>
                <router-link :to="{ name: 'admin.shoots', query: $route.query }">Back</router-link>
            </header>

            <div class="content">

                <label>
                    Title
                    <input v-model="shoot.title"/>
                </label>

                <label>
                    Location
                    <input v-model="shoot.location"/>
                </label>

                <date v-model="shoot.taken_at"></date>

                <upload v-if="shoot.exists" :endpoint="`/api/shoot/${ shoot.shoot_id }/upload`"></upload>
            </div>

            <footer>
                <div class="buttons">
                    <button v-on:click="del" class="button is-primary">Delete</button>

                </div>

                <div class="buttons">
                    <!--<button v-if="shoot.exists && shoot.published_at === null" v-on:click="publish" class="button is-primary">Publish</button>-->


                    <router-link :to="{ name: 'admin.shoots', query: $route.query }" class="button">Cancel</router-link>
                    <router-link v-if="shoot.exists" :to="{ name: 'shoot', params: { id: shoot.shoot_id } }" class="button">View shoot</router-link>
                    <button v-on:click="save" class="button is-primary">Save changes</button>
                </div>
            </footer>
        </template>
    </div>
</template>

<script>
    import Shoot from '../../models/Shoot';
    import User from '../../models/User';

	export default
    {
        data()
        {
            return {
            	loading: false,
                shoot: null,
            };
        },
        methods:
        {
            run( callback, attributes = [] )
            {
            	this.loading = true;
	            callback.apply( this.shoot, attributes ).then( shoot => {
                	this.shoot = shoot;
                    this.loading = false;
                });
            },
	        save()
	        {
		        this.run( this.shoot.save );
	        },
	        publish()
            {
            	this.run( this.shoot.publish );
            },
            del()
            {
                this.shoot.delete().then( () => {
                	this.$router.push( { name: 'shoots' } );
                });
            }
        },

        mounted()
        {
        	if( this.$route.params.id ) {
		        this.run( Shoot.fetch, [this.$route.params.id] );
            } else this.shoot = new Shoot;
	        User.all().then( users => this.users = users );
        },
        params:
        {
            id: {
	            default: null,
                type: Number,
            }
        }
	};
</script>
